import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card } from '../components/ui/Card';
import { checkAdminCredentials, setAdminSession } from '../utils/auth';
import { ShieldIcon, ArrowLeftIcon } from 'lucide-react';
interface AdminLoginProps {
  onSuccess: () => void;
  onBack: () => void;
}
export function AdminLogin({
  onSuccess,
  onBack
}: AdminLoginProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const valid = await checkAdminCredentials(email, password);
      if (valid) {
        await setAdminSession(password);
        onSuccess();
      } else {
        setError('Invalid credentials. Access denied.');
      }
    } catch (err) {
      setError('Authentication error. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  return <div className="min-h-screen bg-zinc-950 flex flex-col items-center justify-center p-4" data-id="element-402">
      <div className="w-full max-w-sm mb-4" data-id="element-403">
        <button onClick={onBack} className="flex items-center gap-2 text-gray-600 hover:text-gray-400 transition-colors text-sm" data-id="element-404">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-405" /> Back
        </button>
      </div>
      <Card className="w-full max-w-sm" data-id="element-406">
        <div className="text-center mb-8" data-id="element-407">
          <ShieldIcon className="w-12 h-12 text-orange-500 mx-auto mb-3" data-id="element-408" />
          <h1 className="text-2xl font-black text-white uppercase tracking-wider" data-id="element-409">
            Admin Access
          </h1>
          <p className="text-gray-500 text-sm mt-1" data-id="element-410">
            Brutes vs Nerds Control Panel
          </p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-411">
          <Input label="Email" type="email" placeholder="admin@example.com" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" data-id="element-412" />
          <Input label="Password" type="password" placeholder="••••••••••••" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" data-id="element-413" />
          {error && <div className="bg-red-950/50 border border-red-800 rounded p-3" data-id="element-414">
              <p className="text-red-400 text-sm font-mono" data-id="element-415">{error}</p>
            </div>}
          <Button type="submit" variant="brawn" size="lg" className="w-full" disabled={loading || !email || !password} data-id="element-416">
            {loading ? 'VERIFYING...' : 'ACCESS PANEL'}
          </Button>
        </form>
      </Card>
    </div>;
}